import React from "react";
import { Routes, Route } from "react-router-dom";

import {urlLocations} from "./urlLocations";
import RouteWrapper from "./RouterWrapper";

import MainLayout from "layouts/MainLayout/MainLayout";
import Containers from 'containers/index';
import AuthorizeLayout from "layouts/AuthorizeLayouts/AuthorizeLayout";
import BasicLayout from "layouts/BasicLayout/BasicLayout";


export default () => {
  return (
    <Routes>
      <Route
        path={urlLocations.dashboard}
        element={
          <BasicLayout>
            <Containers.Dashboard/>
          </BasicLayout>
        }
      />
      <Route
        path={urlLocations.membersPath}
        element={
          <AuthorizeLayout>
            <Containers.Members/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.liturgies}
        element={
          <AuthorizeLayout>
            <Containers.Liturgies/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.liturgyInfo}
        element={
          <AuthorizeLayout>
            <Containers.Liturgy/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.familyInfo}
        element={
          <AuthorizeLayout>
            <Containers.Family/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.marriageNOCDetails}
        element={
          <AuthorizeLayout>
            <Containers.MarriageNOCDetails/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.contributions}
        element={
          <AuthorizeLayout>
            <Containers.Contributions/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.contributionDetails}
        element={
          <AuthorizeLayout>
            <Containers.ContributionDetails/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.marriageNOC}
        element={
          <AuthorizeLayout>
            <Containers.MarriageNoc/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.services}
        element={
          <AuthorizeLayout>
            <Containers.Services/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.memberInfo}
        element={
          <AuthorizeLayout>
            <Containers.Member/>
          </AuthorizeLayout>
        }
      />
      <Route
        path={urlLocations.login}
        element={
          <MainLayout>
            <Containers.Login/>
          </MainLayout>
        }
      />
    </Routes>
  );
}
